import { createSlice } from "@reduxjs/toolkit";

interface GeneralSliceState {
    registerForm: {
        phoneNumber: string,
        username: string,
        privacy: boolean
    },
}
const initialState: GeneralSliceState = {
    registerForm: {
        phoneNumber: "",
        username: "",
        privacy: false
    },
};

const generalSlice = createSlice({
    name: "general",
    initialState,
    reducers: {
        setRegisterForm: (state, action) => {
            state.registerForm = action.payload;
        },
    },
});

export const {
    setRegisterForm
} = generalSlice.actions;

export default generalSlice.reducer;
